import script from "./FaceEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaceEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./FaceEditModal.vue?vue&type=style&index=0&id=0b9d0d64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9d0d64"]])

export default __exports__